import QRCode from 'qrcode';

export const generateQRCode = async (url, options = {}) => {
  const defaultOptions = {
    width: 256,
    margin: 2,
    color: {
      dark: '#000000',
      light: '#FFFFFF'
    },
    errorCorrectionLevel: 'M',
    ...options
  };

  try {
    const qrDataURL = await QRCode.toDataURL(`https://${url}`, defaultOptions);
    return qrDataURL;
  } catch (error) {
    console.error('Error generating QR code:', error);
    throw error;
  }
};

export const downloadQRCode = (dataURL, filename = 'qrcode.png') => {
  const link = document.createElement('a');
  link.download = filename;
  link.href = dataURL;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const shareOnWhatsApp = (url, text = '') => {
  const message = text ? `${text}\n\nhttps://${url}` : `https://${url}`;
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');
};